import instance from './require'

// const sup = 

// 获取信息接口
const getDataInfo = {
  // 上传图片
  upload(name, value, data) {
    return instance.post(`newm/util/uploader/upload?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },

  // 获取店铺信息
  getShopData(name, value, keywords = '') {
    return instance.get(`newm/index/index-interface?${name}=${value}&keywords=${keywords}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取店铺装修 style
  getShopStyle(name, value) {
    return instance.get(`newm/shopdecoration/index?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取商品详情
  getGoods(name, value, id) {
    return instance.get(`newm/index/get-goods?${name}=${value}&id=${id}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取店铺详情信息
  getShopInfo(name, value) {
    return instance.get(`newm/member/index/shop?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取客服信息
  getCustomer(name, value) {
    return instance.get(`newm/member/index/custormer-interface?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取商品管理  信息
  getGoodsAdmin(name, value, status) {
    return instance.get(`newm/member/goods/get-list?${name}=${value}&status=${status}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取仓库中商品  信息
  getAllGoods(name, value) {
    return instance.get(`newm/member/goods/select-data?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取订单奖励信息
  getOrder(name, value, page, status) {
    return instance.get(`newm/member/withdraw/get-order?${name}=${value}&page=${page}&status=${status}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 一键下架商品
  allGoodsDown(name, value, data) {
    return instance.post(`newm/member/goods/change-status-interface?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 下架商品
  goodsDown(name, value, data) {
    return instance.post(`newm/member/goods/change-status?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 一键删除商品
  allGoodsDelete(name, value, data) {
    return instance.post(`newm/member/goods/delete-interface?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 删除商品
  goodsDelete(name, value, data) {
    return instance.post(`newm/member/goods/delete?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 修改商品
  goodsEdit(name, value, data) {
    return instance.post(`newm/member/goods/change?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 一键上架商品
  allGoodsPataway(name, value, data) {
    return instance.post(`newm/member/goods/select-all?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 上架单个商品
  goodsPataway(name, value, data) {
    return instance.post(`newm/member/goods/select-one?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取提现信息
  getWithdrawInfo(name, value) {
    return instance.get(`newm/member/withdraw/apply-info?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取提现信息
  postWithdrawInfo(name, value, data) {
    return instance.post(`newm/member/withdraw/apply-info?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取提现记录
  getWithdrawRecord(name, value, status) {
    return instance.get(`newm/member/withdraw/apply-list?${name}=${value}&status=${status}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取提现记录
  getSettingInfo(name, value) {
    return instance.get(`newm/member/index/setting?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取提现记录
  getNotice(name, value, page) {
    return instance.get(`newm/member/notice/get-list?${name}=${value}&page=${page}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 保存设置
  setSetting(name, value, data) {
    return instance.post(`newm/member/index/setting?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取店长信息
  getManagerInfo(name, value) {
    return instance.get(`newm/member/index/index-info?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 开店缴费
  openShopSubmit(name, value, data) {
    return instance.post(`newm/member/index/apply-agent?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 查询支付状态
  queryPayment(name, value, data) {
    return instance.post(`newm/member/index/pay-wait?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 申请api权限
  applyApi(name, value) {
    return instance.get(`newm/member/index/apply-for-api?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 获取api 信息
  getApiInfo(name, value) {
    return instance.get(`newm/member/index/api?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
}

export default getDataInfo



// WEBPACK FOOTER //
// ./src/utils/getData.js